<template>
  <app-base-main parentTable no-padding>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset" :isBr="false">
        <gj-search-input
            v-model="filter.name"
            width="200px"
            placeholder="模板名称"
        ></gj-search-input>
        <template v-if="!$permission('adsStrategyTemplate:add')" #right>
          <gj-tool-group
              help
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsStrategyTemplate:add')" #operate-group>
      <gj-button type="primary" @click="add">添加模板</gj-button>
    </template>
    <template v-if="$permission('adsStrategyTemplate:add')" #tool-group>
      <gj-tool-group
          help
          :helpName="helpName"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          name="strategyAdjuct"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:header:campaignNum>
          <span class="gj-mr10">活动数</span>
        </template>
        <template v-slot:notifyType="{ row }">
          <template v-if="isMeaningful(row.notifyType)">
            <gj-tooltip v-if="row.notifyType !== 2" :content="row.notifyUserStr" :text-line="1">
              {{row.notifyType|optionText(AdStrategyEnum.resultOption)}}{{' - '+row.notifyUserStr}}
            </gj-tooltip>
            <template v-else>
              {{row.notifyType|optionText(AdStrategyEnum.resultOption)}}
            </template>
          </template>
          <template v-else>
            -
          </template>

        </template>
        <template v-slot:validTime="{row}">
          <template v-if="isMeaningful(row.startDate) || isMeaningful(row.endDate)">
            {{row.startDate | defaultShow}} ~ {{row.endDate | defaultShow}}
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:bidSet="{ row }">
          <app-bid-strategy-set-info
              :item="row"
          ></app-bid-strategy-set-info>
        </template>
        <template v-slot:budgetSet="{ row }">
          <app-budget-strategy-set-info
              :item="row"
          ></app-budget-strategy-set-info>
        </template>
        <template v-slot:placementSet="{ row }">
          <app-placement-strategy-set-info
              :item="row"
          ></app-placement-strategy-set-info>
        </template>
        <template v-slot:campaignNum="{ row }">
          <span class="gj-mr10">
            <template v-if="isMeaningful(row.useNum) && row.useNum > 0">
              <gj-link @click="openUseDetail(row)">{{ row.useNum }}</gj-link>
            </template>
            <template v-else>0</template>
          </span>
        </template>
        <template v-slot:op="{ row }">
          <template v-if="$permission(['adsStrategyObject:add', 'adsStrategyTemplate:update', 'adsStrategyTemplate:delete'], 'all')">
            <gj-button-group type="dropdown-op">
              <gj-button type="text" @click="use(row)">使用</gj-button>
              <gj-button type="text" @click="edit(row)">编辑</gj-button>
              <template #dropdown>
                <gj-dropdown-item @click="deleteItem(row)">删除</gj-dropdown-item>
                <gj-dropdown-item @click="viewLog(row)">日志</gj-dropdown-item>
              </template>
            </gj-button-group>
          </template>
          <template v-else-if="$permissionNum(['adsStrategyObject:add', 'adsStrategyTemplate:update', 'adsStrategyTemplate:delete']) === 2">
            <gj-button-group type="dropdown-op">
              <gj-button
                  v-if="$permission('adsStrategyObject:add')"
                  type="text"
                  @click="use(row)">
                使用
              </gj-button>
              <gj-button
                  v-if="$permission('adsStrategyTemplate:update')"
                  type="text"
                  @click="edit(row)">
                编辑
              </gj-button>
              <gj-button
                  v-if="$permission('adsStrategyTemplate:delete')"
                  type="text"
                  @click="deleteItem(row)">
                删除
              </gj-button>
              <template #dropdown>
                <gj-dropdown-item @click="viewLog(row)">日志</gj-dropdown-item>
              </template>
            </gj-button-group>
          </template>
          <template v-else-if="$permissionNum(['adsStrategyObject:add', 'adsStrategyTemplate:update', 'adsStrategyTemplate:delete']) === 1">
            <gj-button
                v-if="$permission('adsStrategyObject:add')"
                type="text"
                @click="use(row)">
              使用
            </gj-button>
            <gj-button
                v-if="$permission('adsStrategyTemplate:update')"
                type="text"
                @click="edit(row)">
              编辑
            </gj-button>
            <gj-button
                v-if="$permission('adsStrategyTemplate:delete')"
                type="text"
                @click="deleteItem(row)">
              删除
            </gj-button>
            <gj-button
                type="text"
                @click="viewLog(row)">
              日志
            </gj-button>
          </template>
          <template v-else>
            <gj-button
                type="text"
                @click="viewLog(row)">
              日志
            </gj-button>
          </template>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {isMeaningfulMixin, queryMixin} from "../../../../../minxins";
  import {defaultVal, isMeaningful} from "../../../../../utils/common";
  import {getAdsAdjustStrategyTplPage, deleteAdsAdjustStrategyTpl} from "../../../../../api/ad";
  import AppAdTimeAdjustStrategyOpModal from "./modal/strategy-op/time-adjust-strategy-op-modal";
  import {OpEnum} from "../../../../../utils/options";
  import AppStrategyTplUseDetailModal from "./modal/use-detail/strategy-tpl-use-detail-modal";
  import AppStrategyTplUseModal from "./modal/use-tpl/strategy-tpl-use-modal";
  import AppBidStrategySetInfo from "./components/bid-strategy-set-info";
  import AppBudgetStrategySetInfo from "./components/budget-strategy-set-info";
  import AppPlacementStrategySetInfo from "./components/placement-strategy-set-info";
  import AppStrategyTplLogModal from "./modal/log/strategy-tpl-log-modal";
  import {AdStrategyEnum} from '@/views/modules/ad/strategy/common/enum';
  export default {
    name: "app-ad-time-adjust-strategy",
    components: {AppPlacementStrategySetInfo, AppBudgetStrategySetInfo, AppBidStrategySetInfo},
    mixins: [queryMixin, isMeaningfulMixin],
    data() {
      return {
        AdStrategyEnum,
        tableData: [],
        columns: [
          {id: 'templateName', header: '模板名称', field: 'templateName', minWidth: '160px', copyable: true},
          {id: 'notifyType', header: '执行通知', field: 'slot:notifyType', width: '200px'},
          {id: 'validTime', header: '有效时间', field: 'slot:validTime', width: '190px'},
          {id: 'bidSet', header: '竞价设置', field: 'slot:bidSet', minWidth: '200px'},
          {id: 'budgetSet', header: '每日预算设置', field: 'slot:budgetSet', minWidth: '200px'},
          {id: 'placementSet', header: '广告位设置', field: 'slot:placementSet', minWidth: '200px'},
          {id: 'campaignNum', header: 'slot:campaignNum', field: 'slot:campaignNum', width: '100px', align: 'right'},
          {id: 'createDate', header: '创建时间', field: 'createDate', width: '160px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right', notCustomColumn: true},
        ],
        filter: {
          name: null
        },
        notStorage: true,
        helpName: 'timeadjuststrategy',
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            name: null
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            templateName: defaultVal(this.filter.name, null),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getAdsAdjustStrategyTplPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      // 添加模板
      add() {
        this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            opType: OpEnum.type.ADD, // 0
            title: `<span>添加模板</span>`,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppStrategyTplLogModal, {
          props: {
            tplId: row.id,
            tplName: row.name
          }
        });
      },
      deleteItem(row) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: `确定要删除 [${row.templateName}] 吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteAdsAdjustStrategyTpl(row.id)
                .then(() => {
                  this.$gjMessage.success('删除成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      // 模板使用详情
      openUseDetail(row) {
        this.$gjCreate(AppStrategyTplUseDetailModal, {
          props: {
            item: row,
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      // 使用模板
      use(row) {
        this.$gjCreate(AppStrategyTplUseModal, {
          props: {
            item: row,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        });
      },
      // 编辑模板
      edit(row) {
        this.$gjCreate(AppAdTimeAdjustStrategyOpModal, {
          props: {
            opType: OpEnum.type.UPDATE,
            title: `<span>编辑模板</span>`,
            templateId: row.id
          },
          on: {
            updated: () => {
              this.$gjResetPage();
            }
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
